import { EntitySubscriberInterface, EventSubscriber } from 'typeorm'
import DatabaseManager from '@/classes/manager/DatabaseManager'

/*
    This class is only used to keep the SQLite database persisted in the browser.
    It is not included on Platforms other than 'web' [see AppDataSource.ts]
*/

@EventSubscriber()
export class EntityEventSubscriber
  implements EntitySubscriberInterface<unknown>
{
  async afterTransactionCommit() {
    await DatabaseManager.persistMemoryDatabase()
  }
}
